import React from 'react'
import Feedback from '../../../components/feedback'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

export default function CartRemoveWarning({onClose, message}) {
    return (
        <Box data-testid="cart-remove-warning">
            <Feedback
                message={message}
                variant="removeFeedback"
                status="success"
                enableIcon={false}
                onClose={onClose}
            />
        </Box>
    )
}

CartRemoveWarning.propTypes = {
    onClose: PropTypes.func,
    isOpen: PropTypes.bool,
    message: PropTypes.string,
    messageDuration: PropTypes.number,
}
